import flagus from '../assets/images/flags/us.svg';
// import flagspain from "../assets/images/flags/spain.svg";
// import flaggermany from "../assets/images/flags/germany.svg";
// import flagitaly from "../assets/images/flags/italy.svg";
// import flagrussia from "../assets/images/flags/russia.svg";
// import flagfrench from "../assets/images/flags/french.svg";
// import flagarabic from "../assets/images/flags/ae.svg";
import flagthailand from '../assets/images/flags/th.svg';
import flagchina from '../assets/images/flags/cn.svg';
import flagmyanmar from '../assets/images/flags/mm.svg';
import flaglaos from '../assets/images/flags/la.svg';

const languages = {
  // sp: {
  //   label: "Española",
  //   flag: flagspain,
  // },
  // gr: {
  //   label: "Deutsche",
  //   flag: flaggermany,
  // },
  // it: {
  //   label: "Italiana",
  //   flag: flagitaly,
  // },
  // rs: {
  //   label: "русский",
  //   flag: flagrussia,
  // },
  en: {
    label: 'English',
    flag: flagus,
  },
  // fr: {
  //   label: "français",
  //   flag: flagfrench,
  // },
  // ar: {
  //   label: "Arabic",
  //   flag: flagarabic,
  // },
  th: {
    label: 'Thailand',
    flag: flagthailand,
  },
  zh: {
    label: '中文',
    flag: flagchina,
  },
  my: {
    label: 'မြန်မာ',
    flag: flagmyanmar,
  },
  lo: {
    label: 'ລາວ',
    flag: flaglaos,
  },
};

export default languages;
